import en from './languages/en.json';
import no from './languages/no.json';

export default {
	en,
	no,
};
